export const  GET_PRIVACY_POLICY_REQUEST='privacyReducer/GET_PRIVACY_POLICY_REQUEST';
export const  GET_PRIVACY_POLICY_SUCCESS='privacyReducer/GET_PRIVACY_POLICY_SUCCESS';
export const  GET_PRIVACY_POLICY_FAILED='privacyReducer/GET_PRIVACY_POLICY_FAILED';